import styled from 'styled-components';

interface Props {
  height: number;
}

export const ChartWrapper = styled('div')<Props>`
  height: ${({ height }) => height}px;
`;
